import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NoImage from 'assets/icons/trailcard/NoImage.svg';

const useStyles = makeStyles({
  root: {
    borderRadius: '20px',
    margin: '1vh 1vw',
  },
  media: {
    height: 150,
    background: 'center',
    backgroundSize: 'cover',
  },
  subheader: {
    fontFamily: 'Open Sans',
    fontWeight: '600',
    lineHeight: '20px',
    fontSize: '14px',
    letterSpacing: '0.25px',
    /* identical to box height, or 143% */
  },
  managerFlex: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    marginTop: '8px',
  },
  websiteAttr:{
    marginTop: '10px',
    color: '#4D7343',
  },
  poiTitle: {
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
  },
  managerTitle: {
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.25px',
  },
  favoriteFlex: {
    display: 'flex',
    flexDirection: 'column',
    color: '#4D7343',
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    alignItems: 'center',
  },
  directionsFlex: {
    display: 'flex',
    flexDirection: 'column',
    color: '#4D7343',
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    alignItems: 'center',
    height: '25px',
  },
  descriptionText: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '17px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    textAlign: 'left',
    mixBlendMode: 'normal',
    margin: '8px 0',
  },
  backArrowIcon: {
    backgroundSize: 'contain',
    color: 'black',
    height: '24.5px',
    width: '28px',
    cursor: 'pointer'
  }
});


export default function PoiDetails({ attributes, setSidebarSelection }) {
  const classes = useStyles();
  const history = useHistory();

  const gotoDetails = () => {
    setSidebarSelection(null);
    history.push('/details')
  };

  const getDescription = () => {
    return (attributes.COMMENTS ? 
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>
                Description
              </div>
              <div class={classes.descriptionText}>
                <div>{attributes.COMMENTS}</div>
              </div>
            </div>
            : null)
  };

  const getWebsite = () => {
    return (attributes.POI_URL ? 
            <div class={classes.websiteAttr}>
              <a href={attributes.POI_URL} class={classes.subheader} style={{color: 'inherit'}} target='_blank'>More Information</a> 
            </div>  
            : null)
  };

  return (
    <Card className={classes.root}>

      <CardHeader
        avatar={
          <ArrowBackIcon class={classes.backArrowIcon} onClick={() => {gotoDetails()}}></ArrowBackIcon>
        }
        title={attributes.POI_NAME ? attributes.POI_NAME : attributes.SUBTYPE}
        subheader={attributes.SUBTYPE}
        classes={{root: classes.root, title: classes.poiTitle, subheader: classes.subheader}}
      />
      <CardMedia
          className={classes.media}
          image={attributes.IMG_URL ? attributes.IMG_URL : NoImage}
          title="Poi Card"
        />
        <CardContent>
          {getDescription()}
          {getWebsite()}
        </CardContent>
      <CardActionArea>
      </CardActionArea>
    </Card>
  );
}
